export default __webpack_public_path__ + "static/media/Marketing-bro.c7ec37a4.svg";